import React from 'react';
import classNames from 'classnames';
import { ChevronDownIcon } from '@fiverr-private/visuals';
import { grey_900, grey_600 } from '@fiverr-private/sass/helpers';
import { CollapsibleHeaderProps } from '../types';
import { useCollapsibleContext } from '../CollapsibleContext';
import classes from './index.module.scss';

const CollapsibleHeader = ({
  children,
  color = grey_900,
  fontSize = '16px',
  chevronSize = 'md',
  padding = '20px 0',
  hideChevron = false,
}: CollapsibleHeaderProps) => {
  const { toggleExpanded, expanded, disabled } = useCollapsibleContext();
  const headerColor = disabled ? grey_600 : color;

  const chevronClassName = classNames(classes.chevron, {
    [classes.expanded]: expanded,
  });

  const style = {
    padding,
    color: headerColor,
  };

  return (
    <div role="button" aria-expanded={expanded} className={classes.header} onClick={toggleExpanded} style={style}>
      <span className={classes.title} style={{ fontSize }}>
        {children}
      </span>
      {!hideChevron && (
        <span className={chevronClassName}>
          <ChevronDownIcon size={chevronSize} />
        </span>
      )}
    </div>
  );
};

CollapsibleHeader.displayName = 'CollapsibleHeader';

export default CollapsibleHeader;
